<template>
  <div
    class="feedback"
    v-bind:style="{minHeight: `${minHeight}px`}"
  >
    <vignette
      class="feedback-background"
      v-bind:vignette-size="15"
      v-bind:vignette-blur="22.5"
    >
      <img
        v-lazy="'/static/images/contacts/feedback.jpg'"
        alt="Колье из позолоченного серебра 925 пробы"
      >
    </vignette>
    <div
      class="feedback-form"
      ref="feedbackForm"
    >
      <h1>Обратная связь</h1>
      <p>Оставьте свой отзыв или сообщение.</p>
      <p>Мы будем рады узнать Ваше мнение или помочь Вам.</p>
      <form v-on:submit.prevent="sendFeedbackEmail">
        <input
          type="text"
          name="senderName"
          placeholder="  Ваше имя...">
        <input
          type="text"
          name="senderEmail"
          placeholder="* Ваш e-mail..."
          required>
        <input
          type="text"
          name="emailSubject"
          placeholder="* Тема сообщения..."
          required>
        <textarea
          cols="40"
          rows="10"
          name="emailContent"
          placeholder="* Текст сообщения..."
          required
        ></textarea>
        <input
          class="submit"
          type="submit"
          value="Отправить">
      </form>
    </div>
  </div>
</template>

<script>
import Vignette from './utils/Vignette'

export default {
  name: 'ContactsFeedback',
  components: { Vignette },
  data: function () {
    return {
      minHeight: 0
    }
  },
  created () {
    window.addEventListener('resize', this.updateFormHeight)
  },
  destroyed () {
    window.removeEventListener('resize', this.updateFormHeight)
  },
  mounted () {
    this.$nextTick(this.updateFormHeight)
  },
  methods: {
    updateFormHeight: function () {
      this.minHeight = this.$refs.feedbackForm.clientHeight
    },
    async sendFeedbackEmail ($event) {
      const formData = new FormData($event.target)
      const body = Object.fromEntries(formData)

      this.$http
        .post(`${process.env.API_HOST}/api/v1/contacts/send-feedback-email`, body)
        .then(
          response => { alert('Ваше сообщение отправлено, спасибо!') },
          response => {
            console.log(response.data)
            alert(
              'При отправке сообщения возникла ошибка, ' +
              'приносим свои извиенения за доставленные неудобства.')
          })
    }
  }
}
</script>

<style scoped lang="scss">
  @mixin placeholder {
    &::-webkit-input-placeholder {@content}
    &:-moz-placeholder           {@content}
    &::-moz-placeholder          {@content}
    &:-ms-input-placeholder      {@content}
  }

  .feedback {
    position: relative;
    width: 100%;
    max-width: 380px;
    margin: 0 auto;
    font-size: 1.1em;
    h1 { font-size: 1.5em; }

    .feedback-background img {
      opacity: 0.3;
    }
    .feedback-form {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 1;
      padding: 2em 5%;
      box-sizing: border-box;
      form {
        * {
          box-sizing: border-box;
          margin-bottom: 1em;
        }
        *:last-child {
          margin-bottom: 0;
        }
        input, textarea {
          background-color: transparent;
          box-shadow: 0 0 10px 1px #353535 inset;
          border: 1px solid $default-text-color;
          color: $default-link-color;
          font-family: $font-stack;
          transition: 0.5s ease all;
          width: 100%;
          padding: 0.25em 0.5em;

          &:hover {
            border: 1px solid $default-link-color;
          }
          &:focus {
            box-shadow: 0 0 1px 1px $default-link-color;
            border: 1px solid $default-link-color;
          }
        }
        input {
          margin-bottom: 1em;
          @include placeholder {
            text-indent: 0;
            transition: text-indent 0.3s ease;
          }
          &:focus {
            @include placeholder {
              text-indent: 100%;
            }
          }
          &.submit {
            padding: 0.75em 1.25em;
            width: auto;
            float: right;
            cursor: pointer;
            background-color: #111;
            &:focus {
              @include placeholder {
                text-indent: 0;
              }
            }
          }
        }
        textarea {
          display: block;
          resize: none;
          @include placeholder {
            transition: color 0.3s ease;
          }
          &:focus {
            @include placeholder {
              color: transparent;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/ContactsFeedback.vue